// import aT from '../const/action-type'
import initial from '../store/initial'

// dummy reducer for storage versioning
export default (state = initial.version, action) => {
  return state
}
